var render, staticRenderFns
import script from "./BarChartStack.vue?vue&type=script&lang=js"
export * from "./BarChartStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe4660",
  null
  
)

export default component.exports